import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getAllWorkersBySubserviceId = (
  id,
  lat = "",
  lng = "",
  name = "",
  raing = 0,
  date = "",
  companyId = ""
) => {
  const latitude = lat || localStorage.getItem("latitude") || "";
  const longitude = lng || localStorage.getItem("longitude") || "";
  const radiusInKm = 20;

  let companyIdCheck = companyId ? `&companyId=${companyId}` : "";
  const url = `${END_POINTS.getWorkerByCordinates}/${id}?longitude=${lat}&latitude=${lng}&radiusInKm=${radiusInKm}&name=${name}&rating=${raing}&date=${date}${companyIdCheck}`;

  return Api(url, null, REQUEST_TYPE.GET);
};

const getWorkerDetail = (id) => {
  return Api(`${END_POINTS.getWorkerDetail}/${id}`, null, REQUEST_TYPE.GET);
};

const addReviewInWorker = (payload) => {
  return Api(END_POINTS.addReviewInWorker, payload, REQUEST_TYPE.POST);
};

export { getAllWorkersBySubserviceId, getWorkerDetail, addReviewInWorker };
